export const INVENTORY_UPDATE_TYPE_MANUAL = "MANUAL"
export const INVENTORY_UPDATE_TYPE_BULK = "BULK"